export const BrowserLocale = {
  UK: 'en-gb',
  US: 'en-us'
};
